import { isExpiring } from 'applicationTable/ExternalFilters/ExternalFilters.helpers';
import { useApplicationsTableState } from 'components/Dashboard/ApplicationsTable/ApplicationsTableState.context';
import { useDashboard } from 'components/Dashboard/Dashboard.context';
import { addDays, format } from 'date-fns';
import { TFilter } from 'types';

export const useQuickFilters = () => {
  const {
    table: { getColumn, getPreFilteredRowModel },
  } = useApplicationsTableState();

  const { isLoading } = useDashboard();

  const statusFilter = getColumn('status');
  const expiryDateFilter = getColumn('expiryDate');

  const currentStatusValues = statusFilter?.getFilterValue() as
    | string[]
    | undefined;

  const currentExpiryValues = expiryDateFilter?.getFilterValue() as
    | [string, string]
    | undefined;

  const handleClick = (option: TFilter) => {
    if (option.id === 'all') {
      statusFilter?.setFilterValue(undefined);
      expiryDateFilter?.setFilterValue(undefined);
      return;
    }

    statusFilter?.setFilterValue([...option.propertiesToFilterOn]);

    if (option.id === 'expiring') {
      const today = new Date();
      const fromDate = format(today, 'yyyy-MM-dd');
      const toDate = format(addDays(today, 5), 'yyyy-MM-dd');
      expiryDateFilter?.setFilterValue([fromDate, toDate]);
    } else {
      expiryDateFilter?.setFilterValue(undefined);
    }
  };

  const isFilterActive = (option: TFilter) => {
    if (option.id === 'all') {
      return !currentStatusValues?.length && !currentExpiryValues;
    }

    if (option.id === 'expiring') {
      return (
        !!currentExpiryValues &&
        option.propertiesToFilterOn?.every((property) =>
          currentStatusValues?.includes(property),
        )
      );
    }

    return (
      option.propertiesToFilterOn?.every((property) =>
        currentStatusValues?.includes(property),
      ) && !currentExpiryValues
    );
  };

  const getFilteredCount = (option: TFilter) => {
    const preFilteredRows = getPreFilteredRowModel().rows;
    const filteredRows = preFilteredRows.filter((row) => {
      const matchesStatus = option.propertiesToFilterOn.includes(
        row.original.status,
      );
      if (option.id === 'expiring') {
        const expiry =
          row.original.formal_offer_sets?.[0]?.formal_offers?.[0]?.timeout;
        return matchesStatus && expiry && isExpiring(expiry);
      }
      return matchesStatus;
    });

    return filteredRows.length;
  };

  return {
    isLoading,
    getFilteredCount,
    isFilterActive,
    handleClick,
  };
};
